export const SHOW_TOAST_MESSAGE = 'SHOW_TOAST_MESSAGE';
export const CLEAR_TOAST_DATA = 'CLEAR_TOAST_DATA';

const showToastMessage = messageData => ({
    type: SHOW_TOAST_MESSAGE,
    payload: messageData
});

const clearToastData = () => ({
    type: CLEAR_TOAST_DATA
});

export default {
    showToastMessage,
    clearToastData
};



// WEBPACK FOOTER //
// ./components/toast/toast-actions.js